// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3YMIb","label":"Labeled_label__1SV9Q","divider":"Labeled_divider__2J2Hj"};